import "./LeftPanel.css";

interface HeaderProps {
  collapsed: boolean;
  onCollapsedChange: (collapsed: boolean) => void;
  username?: string;
  isAdmin?: boolean;
  onAdminClick?: () => void;
  onProfileClick?: () => void;
  onLogout?: () => void;
  streamPanelOpen?: boolean;
  onStreamPanelToggle?: () => void;
}

export function Header({
  collapsed,
  onCollapsedChange,
  username,
  isAdmin,
  onAdminClick,
  onProfileClick,
  onLogout,
  streamPanelOpen,
  onStreamPanelToggle,
}: HeaderProps) {
  return (
    <div className="top-header">
      <div className="header-left-group">
        <button
          className={`header-btn ${!collapsed ? "active" : ""}`}
          onClick={() => onCollapsedChange(!collapsed)}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
          </svg>
          <span>{collapsed ? "Show Files" : "Hide Files"}</span>
        </button>
        {onStreamPanelToggle && (
          <button
            className={`header-btn ${streamPanelOpen ? "active" : ""}`}
            onClick={onStreamPanelToggle}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
              <line x1="8" y1="21" x2="16" y2="21" />
              <line x1="12" y1="17" x2="12" y2="21" />
            </svg>
            <span>{streamPanelOpen ? "Hide Stream" : "Show Stream"}</span>
          </button>
        )}
      </div>
      <div className="header-spacer" />
      <div className="header-right-group">
        {isAdmin && onAdminClick && (
          <button
            className="header-btn"
            onClick={onAdminClick}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="3" />
              <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z" />
            </svg>
            <span>Admin</span>
          </button>
        )}
        {username && (
          <button
            className="header-btn username-btn"
            onClick={onProfileClick}
            title="Profile settings"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
            <span>{username}</span>
          </button>
        )}
        {onLogout && (
          <button
            className="header-btn logout-btn"
            onClick={onLogout}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
            <span>Logout</span>
          </button>
        )}
      </div>
    </div>
  );
}

interface FilesPanelProps {
  width: number;
  children: React.ReactNode;
}

export function FilesPanel({ width, children }: FilesPanelProps) {
  return (
    <div className="files-panel" style={{ width }}>
      {children}
    </div>
  );
}
